import { DescripcionesTab } from 'features/master';

const DescripcionesPage = () => <DescripcionesTab />;

export default DescripcionesPage;
